exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-standard-overrides-modal {\r\n  min-height: 240px;\r\n}\r\n.alert .btn {\r\n  white-space: normal;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/employee-standard-overrides-modal/employee-standard-overrides-modal.component.css
// module id = ../../../../../src/app/content-page/views/view-group/popups/employee-standard-overrides/employee-standard-overrides-modal/employee-standard-overrides-modal.component.css
// module chunks = main